import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Custom__qgiv-filter",
  "use": "Custom__qgiv-filter-usage",
  "viewBox": "0 0 14 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 14 11\" id=\"Custom__qgiv-filter\"><path fill=\"currentColor\" d=\"M0 .718C0 .322.336 0 .75 0h12.5c.416 0 .75.322.75.718 0 .397-.334.717-.75.717H.75c-.414 0-.75-.32-.75-.717ZM0 5.5c0-.397.336-.717.75-.717h8.5c.416 0 .75.32.75.717 0 .398-.334.718-.75.718H.75c-.414 0-.75-.32-.75-.718ZM5.25 11H.75c-.414 0-.75-.32-.75-.717 0-.397.336-.717.75-.717h4.5c.416 0 .75.32.75.717 0 .398-.334.718-.75.718Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol